














import {Component, Vue} from "vue-property-decorator";
import {faHome} from "@fortawesome/free-solid-svg-icons";
import {AuthService} from "@/services/auth";
import {IUser} from "shared/entities/user";


@Component({
})
export default class TopNavBar extends Vue {
    private user: IUser | null = null;
    private icons = {faHome};

    async mounted() {
        if (AuthService.user) {
            this.user = AuthService.user;
        }
        AuthService.Events.$on("auth-change", (u: IUser) => {
            this.user = u;
            this.$forceUpdate();
        });
    }

    async logout() {
        await AuthService.clear();
        await this.$router.push("/authorize");
    }

}

